import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 8c0 .733.6 1.333 1.333 1.333.734 0 1.334-.6 1.334-1.333s-.6-1.333-1.334-1.333C2.6 6.667 2 7.267 2 8ZM11.333 8c0 .733.6 1.333 1.334 1.333C13.4 9.333 14 8.733 14 8s-.6-1.333-1.333-1.333c-.734 0-1.334.6-1.334 1.333ZM6.667 8c0 .733.6 1.333 1.333 1.333S9.333 8.733 9.333 8 8.733 6.667 8 6.667 6.667 7.267 6.667 8Z"
    />
  </svg>
)
export default SvgComponent
